import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
  BooleanInput,
  DateTimeInput,
  required,
  minValue,
  TopToolbar,
  ShowButton,
  DeleteButton,
} from "react-admin";

const subscriptionStatuses = [
  { id: "active", name: "Активна" },
  { id: "expired", name: "Истекла" },
  { id: "cancelled", name: "Отменена" },
  { id: "suspended", name: "Приостановлена" },
  { id: "pending", name: "Ожидает" },
];

const currencies = [
  { id: "USD", name: "USD" },
  { id: "EUR", name: "EUR" },
  { id: "RUB", name: "RUB" },
];

const UserSubscriptionEditActions = () => (
  <TopToolbar>
    <ShowButton />
    <DeleteButton />
  </TopToolbar>
);

export const UserSubscriptionEdit = () => {
  return (
    <Edit
      actions={<UserSubscriptionEditActions />}
      title="Редактировать подписку пользователя"
    >
      <SimpleForm>
        <TextInput
          source="userId"
          label="ID пользователя"
          validate={[required()]}
          fullWidth
          disabled
        />
        <ReferenceInput
          source="subscriptionPlanId"
          reference="subscriptionPlans"
          label="План подписки"
        >
          <SelectInput optionText="name" validate={[required()]} fullWidth />
        </ReferenceInput>
        <SelectInput
          source="status"
          label="Статус"
          choices={subscriptionStatuses}
          validate={[required()]}
        />
        <DateTimeInput
          source="startDate"
          label="Дата начала"
          validate={[required()]}
        />
        <DateTimeInput
          source="endDate"
          label="Дата окончания"
          validate={[required()]}
        />
        <DateTimeInput source="cancelledAt" label="Дата отмены" />
        <DateTimeInput source="renewedAt" label="Дата продления" />
        <NumberInput
          source="amountPaid"
          label="Сумма оплаты"
          validate={[minValue(0)]}
          step={0.01}
        />
        <SelectInput source="currency" label="Валюта" choices={currencies} />
        <TextInput
          source="paymentTransactionId"
          label="ID транзакции"
          fullWidth
        />
        <BooleanInput source="autoRenew" label="Автопродление" />
      </SimpleForm>
    </Edit>
  );
};
